/* -------------------------------------------------------------------------- */
/*                        Page title styles                        */
/* -------------------------------------------------------------------------- */

@import './bq-page-title.variables';

:host {
  @apply block;
}
